<template>
  <section
    class="hero-branding bg-cover"
    style="background-color: black"
    id="home"
  >
    <div class="container-fluid container-fluid--cp-150">
      <div class="row hero-startup">
        <div class="col-md-6">
          <div class="hero-content">
            <v-img
              :src="require('../assets/tlLogo.svg')"
              contain
              height="200"
            ></v-img>
            <v-container>
              <h2 class="h1 hero-content-title font-weight--bold">
                Get Better Results For Your Clients
                <span class="section-title">80% Faster!</span>
              </h2>
              <h6 class="hero-content-subtitle mt-20">
                Engage clients, Hire experts, Automate output <br />
                IN A SINGLE APPLICATION

                <!-- TapLaw is the only zero-dependency, one-stop, cloud-based
              application that automates the most time-consuming parts of
              dispute resolution for law firms, consumers, and 3rd parties. -->
              </h6>
            </v-container>
            <div class="slider-button mt-30">
              <router-link to="/signup" class="btn btn--green"
                >Get Started</router-link
              >
              <h6 class="sub-heading">
                Questions?
                <router-link
                  to=""
                  class="hover-style-link hover-style-link--green"
                  >Talk to our team</router-link
                >
              </h6>
            </div>
          </div>
        </div>
        <div class="col-md-6 align-self-end hidden-sm-and-down">
          <div class="startup-thumb ">
            <img
              src="../assets/img/hero/startup/startup-thumb.png"
              class="img-fluid"
              alt="startup-thumb"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      bgImg: {
        // backgroundImage: `url(${require("../assets/img/hero/startup/background_landing.png")})`
        backgroundImage: `url(${require("../assets/img/hero/startup/tingey-injury-law-firm-nSpj-Z12lX0-unsplash.jpg")})`
        // backgroundImage: `url(${require("../assets/img/hero/startup/startup-bg.jpg")})`
      }
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variabls.scss";
@import "../assets/scss/elements/_hero-branding.scss";
.hidden-sm-and-down {
  @media (max-width: 767px) {
    display: none !important;
  }
}
.hero-branding {
  // responsive
  @media #{$large-mobile} {
    height: 950px;
  }
}
.hero-startup {
  align-items: center;
  display: flex;
  height: 100vh;
  .startup-thumb {
    bottom: -32px;
    position: relative;
    z-index: 1;
    // responsive
    @media #{$tablet-device} {
      bottom: -15px;
    }
  }
}
.hero-content {
  // responsive
  @media #{$tablet-device} {
    width: 100%;
  }
  &-title,
  &-subtitle {
    color: $white;
  }
  .slider-button {
    display: flex;
    align-items: center;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      display: block;
    }
  }
  .sub-heading {
    font-size: 15px;
    color: $white;
    padding-left: 20px;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      padding-left: 0;
      padding-top: 15px;
    }
  }
}
</style>
